import { inject, Injectable, isDevMode } from '@angular/core';
import { map, shareReplay, tap } from 'rxjs/operators';
import { EMPTY, fromEvent, merge, Observable, of } from 'rxjs';
import { BrowserContext } from './browser-context.service';

@Injectable({
  providedIn: 'root',
})
export class OnlineService {
  private readonly ctx = inject(BrowserContext);

  public readonly online$: Observable<'online'>;
  public readonly offline$: Observable<'offline'>;
  public readonly status$: Observable<'online' | 'offline'>;

  constructor() {
    if (this.ctx.isBrowser) {
      this.online$ = fromEvent(this.ctx.window, 'online').pipe(map(() => 'online'));
      this.offline$ = fromEvent(this.ctx.window, 'offline').pipe(map(() => 'offline'));
      this.status$ = merge(
        of(this.ctx.window.navigator.onLine).pipe(map(value => (value ? 'online' : 'offline'))),
        this.online$,
        this.offline$
      ).pipe(
        tap((value: 'online' | 'offline') => isDevMode() && console.log('RX Online:', value)),
        shareReplay(1)
      );
    } else {
      this.online$ = EMPTY;
      this.offline$ = EMPTY;
      this.status$ = of('online');
    }
  }
}
